import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { ValidationService } from "src/app/core/validation.service";
import { AuthService } from "src/app/core/auth/auth.service";
import { Router } from "@angular/router";
import { AlertService } from "src/app/core/alert/alert.service";
import { ForgotPasswordRequest } from "../interface/authentication";

@Component({
standalone: false,
  selector: "app-recover-password",
  templateUrl: "./recover-password.component.html",
  styleUrls: ["./recover-password.component.scss"]
})
export class RecoverPasswordComponent implements OnInit {
  recoverPasswordForm: UntypedFormGroup;
  validationMessage: any;
  isLoading: boolean;
  isResetLinkSent: boolean = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private validationMessages: ValidationService,
    private authService: AuthService,
    private router: Router,
    public alertService: AlertService
  ) {
    this.validationMessage = validationMessages;
  }

  ngOnInit() {
    this.initializeForm();
    localStorage.clear();
    this.isLoading = false;
  }

  initializeForm() {
    this.recoverPasswordForm = this.formBuilder.group({
      email: ["", Validators.compose([Validators.required, Validators.email])]
    });
  }

  sendLink() {
    this.isLoading = true;
    const forgotPasswordRequest: ForgotPasswordRequest = {
      email: this.recoverPasswordForm.value.email
    }
    this.authService.sendLink(forgotPasswordRequest).subscribe(
      response => {
        this.isLoading = false;
        this.alertService.success("Link sent successfully", true);
        this.recoverPasswordForm.reset();
        this.isResetLinkSent = true
      },
      error => {
				this.isLoading = false;
				if (error.error["responseCode"] && error.error["responseCode"] === "RESOURCE_NOT_FOUND") {
					this.alertService.warn("Check your email for reset link");
					return;
				}

        if (error.status !== 403) {
          this.alertService.warn(error.error.responseMessage);
        } else {
          this.alertService.warn(error.error.responseMessage);
          setTimeout(() => {
            this.alertService.error(error);
          }, 2000);
        }
      }
    );
  }
}
